import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import ConfirmModal from "../Confirm";
import { deleteTrashItems } from "../../../../store/File/actions";
import {
  MODAL_CONFIRM,
  MODAL_PERMANENTLY_DELETE,
} from "../../../../store/Modals/constants";
import { CONFIRM_PERMANENTLY_DELETE_MESSAGE } from "../Confirm/constants";
import { openModal } from "../../../../store/Modals/actions";

const PermanentlyDelete = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(openModal(MODAL_CONFIRM));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ConfirmModal
      modal={MODAL_PERMANENTLY_DELETE}
      action={() => dispatch(deleteTrashItems())}
      message={CONFIRM_PERMANENTLY_DELETE_MESSAGE}
    />
  );
};

export default PermanentlyDelete;
